import React from 'react';
import { Modal, Space, Button, Typography } from 'antd';
import { CloudUploadOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { getFileTypeIcon, formatFileSize } from './collectionUtils';

const { Text } = Typography;

const UploadModal = ({ open, files, uploading, onCancel, onUpload, onRemoveFile, onAddMore }) => (
    <Modal
        title={<Space><CloudUploadOutlined style={{ color: 'var(--color-primary)' }} /><span>Upload Files to Collection</span></Space>}
        open={open}
        onCancel={onCancel}
        onOk={onUpload}
        confirmLoading={uploading}
        okText={`Upload ${files.length} File${files.length !== 1 ? 's' : ''}`}
        width={500}
        className="upload-modal"
    >
        <div className="upload-files-list">
            {files.map((f, idx) => (
                <div key={idx} className="upload-file-item">
                    <Space>
                        {getFileTypeIcon(f.name.split('.').pop(), 'file')}
                        <div style={{ lineHeight: 1.2 }}>
                            <div style={{ fontWeight: 500, lineHeight: 1.1 }}>{f.name}</div>
                            <Text type="secondary" style={{ fontSize: 12, marginTop: -2, display: 'block', lineHeight: 1.1 }}>{formatFileSize(f.size)}</Text>
                        </div>
                    </Space>
                    <Button type="text" danger size="small" icon={<DeleteOutlined />} onClick={() => onRemoveFile(idx)} />
                </div>
            ))}
            <Button type="dashed" block style={{ marginTop: 12 }} onClick={onAddMore} icon={<PlusOutlined />}>
                Add More Files
            </Button>
        </div>
    </Modal>
);

export default UploadModal;
